import { Component } from 'react';
import '../../../../styles/components/lucky-draw-spinner.scss';
import { Loader, Maximize2, Minimize2, PartyPopper, RotateCw, Sparkles } from 'lucide-react';
import { Spin } from './services/bloodDonationServices';
import { toast } from 'react-toastify';

class LuckyDrawSpinner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      digit1: 0,
      digit2: 0,
      digit3: 0,
      isSpinning: false,
      winnerNumber: null,
      showWinnerModal: false,
      remaining: null,
      isIphone: false,
      showCompletionPage: false,
      isFullscreen: false,
    };
    this.spinInterval = null;
    this.stopTimeout = null;
  }

  componentDidMount() {
    // Listen for fullscreen changes
    document.addEventListener('fullscreenchange', this.handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange);
  }

  componentWillUnmount() {
    if (this.spinInterval) clearInterval(this.spinInterval);
    if (this.stopTimeout) clearTimeout(this.stopTimeout);
    // Remove fullscreen event listeners
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange);
  }

  startSpin = async () => {
    if (this.state.isSpinning) return;

    this.setState({
      isSpinning: true,
      showWinnerModal: false,
      winnerNumber: null,
    });

    // Animate numbers scrolling
    this.spinInterval = setInterval(() => {
      this.setState({
        digit1: Math.floor(Math.random() * 10),
        digit2: Math.floor(Math.random() * 10),
        digit3: Math.floor(Math.random() * 10),
      });
    }, 50);

    // Stop after 2 seconds and call API
    this.stopTimeout = setTimeout(async () => {
      try {
        const data = await Spin();
        // Stop spinning and set winner number
        if (!data.success) {
          toast.error(data.message);
          clearInterval(this.spinInterval);
          this.setState({ isSpinning: false, showCompletionPage: true });
          return;
        }
        this.stopSpinning(data.winner_number, data.is_iphone, data.remaining);
      } catch (error) {
        console.error('Error calling spin API:', error);
        clearInterval(this.spinInterval);
        this.setState({ isSpinning: false });
        toast.error('Something went wrong. Please try again.');
      }
    }, 2000);
  };

  stopSpinning = (winnerNumber, isIphone, remaining) => {
    clearInterval(this.spinInterval);

    const winnerStr = winnerNumber.toString().padStart(3, '0');
    const digit1 = parseInt(winnerStr[0]);
    const digit2 = parseInt(winnerStr[1]);
    const digit3 = parseInt(winnerStr[2]);

    this.setState({
      digit1,
      digit2,
      digit3,
      winnerNumber,
      isIphone,
      remaining,
    });

    // Show winner modal after 1/2 seconds
    setTimeout(() => {
      this.setState({
        isSpinning: false,
        showWinnerModal: true,
      });
    }, 500);
  };

  closeModal = () => {
    const { remaining } = this.state;

    // Check if remaining is 0, show completion page
    if (remaining === 0) {
      this.setState({
        showWinnerModal: false,
        showCompletionPage: true,
      });
    } else {
      this.setState({ showWinnerModal: false });
    }
  };

  handleFullscreenChange = () => {
    const isCurrentlyFullscreen = !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    );

    this.setState({ isFullscreen: isCurrentlyFullscreen });
  };

  toggleFullscreen = () => {
    const elem = document.documentElement;

    if (this.state.isFullscreen) {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen(); // Safari
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen(); // Firefox
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen(); // IE/Edge
      }
    } else {
      // Enter fullscreen
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen(); // Safari
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen(); // Firefox
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen(); // IE/Edge
      }
    }
  };
  render() {
    const {
      digit1,
      digit2,
      digit3,
      isSpinning,
      showWinnerModal,
      winnerNumber,
      isIphone,
      showCompletionPage,
      isFullscreen,
    } = this.state;

    // Show completion page
    if (showCompletionPage) {
      return (
        <div className="completion-page">
          <div className="completion-backdrop"></div>
          <div className="completion-glow-orb completion-glow-orb-1"></div>
          <div className="completion-glow-orb completion-glow-orb-2"></div>

          <div className="completion-content">
            <div className="completion-shine"></div>

            <div className="completion-icon-wrapper">
              <div className="completion-icon">
                <PartyPopper size={80} strokeWidth={1.5} />
              </div>
              <div className="completion-icon-ring"></div>
            </div>

            <h1 className="completion-title">
              <span className="completion-title-text">Lucky Draw</span>
              <span className="completion-title-text">Completed!</span>
            </h1>

            <div className="completion-divider">
              <Sparkles size={20} />
            </div>

            <p className="completion-message">Thank you to all our generous blood donors!</p>

            <div className="completion-footer">
              <div className="blood-drop-icon-wrapper">
                <div className="blood-drop-icon">
                  <svg viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C12 2 5 8.5 5 13.5C5 17.64 8.36 21 12.5 21C16.64 21 20 17.64 20 13.5C20 8.5 12 2 12 2Z" />
                  </svg>
                </div>
              </div>
              <p className="completion-tagline">Your contribution saves lives </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="lucky-draw-container">
        {/* Fullscreen Button */}
        <button
          className="fullscreen-button"
          onClick={this.toggleFullscreen}
          aria-label={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
          title={isFullscreen ? 'Exit Fullscreen' : 'Enter Fullscreen'}
        >
          {isFullscreen ? <Minimize2 size={24} /> : <Maximize2 size={24} />}
        </button>
        {/* Enhanced Background Effects */}
        <div className="bg-gradient-overlay"></div>
        <div className="glow-orb glow-orb-1"></div>
        <div className="glow-orb glow-orb-2"></div>
        <div className="glow-orb glow-orb-3"></div>

        {/* Animated blood drops */}
        <div className="blood-drops">
          {[...Array(25)].map((_, i) => (
            <div
              key={i}
              className="blood-drop"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${5 + Math.random() * 5}s`,
              }}
            ></div>
          ))}
        </div>

        {/* Main Content */}
        <div className="main-content">
          {/* Spinner Section */}
          <div className="spinner-section">
            {/* <div className="winning-label">
              <Sparkles size={16} className="label-icon" />
              <span>WINNING NUMBER</span>
              <Sparkles size={16} className="label-icon" />
            </div> */}

            <div className="spinner-wrapper">
              <div className="spinner-glow"></div>

              <div className="spinner-container">
                <div className="spinner-frame">
                  {/* Decorative corners */}
                  <div className="frame-corner frame-corner-tl"></div>
                  <div className="frame-corner frame-corner-tr"></div>
                  <div className="frame-corner frame-corner-bl"></div>
                  <div className="frame-corner frame-corner-br"></div>

                  {/* Left decorations */}
                  <div className="frame-decoration frame-left">
                    <div className="deco-bolt"></div>
                    <div className="deco-bolt"></div>
                    <div className="deco-bolt"></div>
                  </div>

                  {/* Digit Display */}
                  <div className="spinner-display">
                    <div className={`digit-box ${isSpinning ? 'spinning' : ''}`}>
                      <div className="digit-inner">
                        <div className="digit digit-red">{digit1}</div>
                      </div>
                    </div>

                    <div className={`digit-box ${isSpinning ? 'spinning' : ''}`}>
                      <div className="digit-inner">
                        <div className="digit">{digit2}</div>
                      </div>
                    </div>

                    <div className={`digit-box ${isSpinning ? 'spinning' : ''}`}>
                      <div className="digit-inner">
                        <div className="digit">{digit3}</div>
                      </div>
                    </div>
                  </div>

                  {/* Right decorations */}
                  <div className="frame-decoration frame-right">
                    <div className="deco-bolt"></div>
                    <div className="deco-bolt"></div>
                    <div className="deco-bolt"></div>
                  </div>
                </div>
              </div>
            </div>

            {/* Spin Button */}
            <button
              className={`spin-button ${isSpinning ? 'spinning' : ''}`}
              onClick={this.startSpin}
              disabled={isSpinning}
            >
              <span className="button-glow"></span>
              <span className="button-content">
                <RotateCw className="button-icon" strokeWidth={2.5} />
                <span className="button-text">SPIN NOW</span>
              </span>
            </button>

            <p className="status-text">
              {isSpinning ? (
                <>
                  <span className="status-icon ">
                    <Loader className="animate-spin" />
                  </span>
                  SPINNING...
                </>
              ) : (
                <>
                  <span className="status-icon"></span>
                  WAITING FOR THE NEXT DONOR
                </>
              )}
            </p>
          </div>
        </div>

        {/* Winner Modal */}
        {showWinnerModal && (
          <div className="modal-overlay-l2" onClick={this.closeModal}>
            {/* Confetti */}
            <div className="confetti-wrapper">
              {[...Array(150)].map((_, i) => (
                <div
                  key={i}
                  className="confetti-piece"
                  style={{
                    left: `${Math.random() * 100}%`,
                    animationDelay: `${Math.random() * 3}s`,
                    backgroundColor:
                      i % 4 === 0
                        ? '#EF4444'
                        : i % 4 === 1
                          ? '#FFF'
                          : i % 4 === 2
                            ? '#FBBF24'
                            : '#DC2626',
                    animationDuration: `${2 + Math.random() * 2}s`,
                  }}
                ></div>
              ))}
            </div>

            <div className="winner-modal" onClick={(e) => e.stopPropagation()}>
              <div className="modal-bg-glow"></div>
              <div className="modal-shine"></div>

              <div className="celebration-badge">
                <PartyPopper size={30} strokeWidth={1.5} />
              </div>

              <h2 className="modal-title">
                <span className="modal-title-line">CONGRATULATIONS!</span>
              </h2>

              <div className="winner-display">
                <div className="winner-display-glow"></div>
                <div className="winner-label">GIFT NUMBER</div>
                <div className="winner-number">{winnerNumber?.toString().padStart(3, '0')}</div>
              </div>

              {isIphone && (
                <div className="prize-banner">
                  <div className="prize-banner-shine"></div>
                  <div className="prize-icon">🎁</div>
                  <div className="prize-details">
                    <div className="prize-label">GRAND PRIZE WINNER</div>
                    <div className="prize-name">iPhone 16 Pro Max! 🎉</div>
                  </div>
                </div>
              )}

              <div className="thank-you-card">
                <p className="thank-you-text">Thank you for your generous blood donation!</p>
                {/* <p className="thank-you-subtext">
                  <span className="heart-pulse">❤️</span> Your contribution saves lives 🩸
                </p> */}
              </div>

              <button className="modal-button" onClick={this.closeModal}>
                <span className="modal-button-glow"></span>
                <span className="modal-button-text">CONTINUE</span>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LuckyDrawSpinner;
